import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { TreeModule } from 'primeng';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss'],
  providers:[ScheduleService,MasterService]
})
export class SmsComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrschnote:any=[];
  mascls=[];
  massec=[];
  arrstudent=[];
  arrassesment=[];
  masdept=[];
  arrstaff=[];
  asmtid='1';

  constructor(private http: HttpClient, private sservice: ScheduleService,private mservice:MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.masclass();
    this.masasshead();
 
  }

  selectedAll: any=false;
  selectAll() {
      for (var i = 0; i < this.arrstudent.length; i++) {
        this.arrstudent[i].selected = this.selectedAll;
      }
    }
    checkIfAllSelected() {
      this.selectedAll = this.arrstudent.every(function(item:any) {
          return item.selected == true;
        })
    }
  masclass() {
    this.mservice.classmasterrolewise(0,0,0,'asa')
        .subscribe(
        resultArray => {
            
            
          //  resultArray.map(obj=> ({ ...obj, selected: 'false' }));
            resultArray.forEach(function (element) {
              element.selected = false;
            });
            this.mascls = resultArray;
            console.log('getdashcounts', resultArray);
           // this.mascls.map(obj=> ({ ...obj, selected: 'false' }));
            // this.fmodel.clid=resultArray[0].clid;
            // this.massection();
            // this.masperiod();
            
           
        },
        error => console.log("Error :: " + error)
        )

        
      console.log('mascls', this.mascls);
  }

  gethrmdepts() {
    debugger;
    this.mservice.get_hrmdept()
        .subscribe(
        resultArray => {
            
            
          //  resultArray.map(obj=> ({ ...obj, selected: 'false' }));
            resultArray.forEach(function (element) {
              element.selected = false;
            });
            this.masdept = resultArray;
            console.log('gethrmdepts', resultArray);
           // this.mascls.map(obj=> ({ ...obj, selected: 'false' }));
            // this.fmodel.clid=resultArray[0].clid;
            // this.massection();
            // this.masperiod();
            
           
        },
        error => console.log("Error :: " + error)
        )

        
      console.log('mascls', this.mascls);
  }

  classsections() {
    var selclass=this.mascls.filter(item => item.selected===true);
    console.log('selclass',selclass);
    this.mservice.getclasssection(selclass)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.massec = resultArray;
            // this.fmodel.clid=resultArray[0].clid;
            // this.massection();
            // this.masperiod();
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getstudentclasssecwise() {
    var selclass=this.massec.filter(item => item.selected===true);
    console.log('selclass',selclass);
    this.mservice.getstudentclasssecwise(selclass)
        .subscribe(
        resultArray => {
            console.log('stulst', resultArray);
            this.arrstudent = resultArray;
            // this.fmodel.clid=resultArray[0].clid;
            // this.massection();
            // this.masperiod();
            
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getdeptwisestaff() {
    var selclass=this.masdept.filter(item => item.selected===true);
    console.log('selclass',selclass);
    this.mservice.getstaffdeptwise(selclass)
        .subscribe(
        resultArray => {
            console.log('stulst', resultArray);
            this.arrstaff = resultArray;
            // this.fmodel.clid=resultArray[0].clid;
            // this.massection();
            // this.masperiod();
            
           
        },
        error => console.log("Error :: " + error)
        )
  }
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            
            
          
            this.arrassesment = resultArray;
            console.log('getdashcounts', resultArray);
           
        },
        error => console.log("Error :: " + error)
        )

        
      console.log('mascls', this.mascls);
  }
  sendmarks()
  {
    var stulst=this.arrstudent.filter(item => item.selected===true);
    console.log('assid',this.asmtid);
    var postdata={assid:this.asmtid,stulst:stulst};

    this.sservice.sendmarkssms(postdata)
    .subscribe(
    resultArray => {
        console.log('stulst', resultArray);
       // this.arrstudent = resultArray;
        // this.fmodel.clid=resultArray[0].clid;
        // this.massection();
        // this.masperiod();
        
       
    },
    error => console.log("Error :: " + error)
    )
  }

}
